import {
defineCustomElement,
MediaSliderPreviewElement,
MediaSliderThumbnailElement
} from "vidstack/elements";

defineCustomElement(MediaSliderPreviewElement);
defineCustomElement(MediaSliderThumbnailElement);